module.exports = __webpack_public_path__ + "static/media/socialMedia.63d2fc55.png";